<template>
  <div class="h-[57px] ">
    <div class="border-b bg-white w-full fixed top-0 z-[999]">
      <nav class="flex w-[1200px] mx-auto items-center justify-between h-16  ">
        <div class="flex items-center">
          <i class="iconfont-logo logoIcon-fazhibaohantonglogo text-[30px] text-[#A11710]"></i>
          <span class="text-[18px] text-[#303133] font-semibold pl-[4px]">法智保诉讼保全保函平台</span>
        </div>
        <div class="flex items-center space-x-16 text-[#191A24]">
          <span @click="push({ path: '/' })" :class="{ 'active': crurentPath == '/' }"
            class="cursor-pointer  ">首页</span>
          <span @click="push({ path: '/scene' })" :class="{ 'active': crurentPath == '/scene' }"
            class="cursor-pointer  ">场景应用</span>

          <span @click="push({ path: '/finance' })"
            :class="{ 'active': crurentPath == '/finance' || crurentPath == '/financeEntry' }"
            class="cursor-pointer  ">金融机构</span>
          <span @click="push({ path: '/news' })" :class="{ 'active': crurentPath == '/news' }"
            class="cursor-pointer ">政策资讯</span>
          <span @click="push({ path: '/help/index' })" :class="{ 'active': crurentPath == '/help/index' }" class="cursor-pointer ">帮助中心</span>
          <span @click="push({ path: '/introduce' })" :class="{ 'active': crurentPath == '/introduce' }"
            class="cursor-pointer  ">关于我们</span>
          <a href="https://user.bjfzt.com/#/" target="_blank" class="flex items-center  ">
            <i class="fas icon mr-1">&#xe750;</i>

            {{ userInfo.realName || '登录' }}
          </a>
        </div>
      </nav>
    </div>

  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
  mixins: [mixin],
  name: 'dg-nav',
  data() {
    return {
      crurentPath: '',
      userInfo: {
        realName: '',
      }
    }
  },
  watch: {
    $route(to) {
      this.crurentPath = to.path
    }
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      ajax.post({
        url: '/customer/user/current',
        data: {
          type: 1
        },
        self: this,
        success: (res) => {
          if (res) {

            this.userInfo = res.user;
          }
        },
        fail: () => { },
      })

    }
  },
  mounted() {
  },
  created() {
    this.getUserInfo();

  },
}
</script>
<style scoped lang="less">
.active {
  color: #A11710;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;
    background: #A11710;
    bottom: -17px;
    left: 0;
  }
}
</style>
